import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=c2c2a182&scoped=true"
import script from "./VideoList.vue?vue&type=script&lang=js"
export * from "./VideoList.vue?vue&type=script&lang=js"
import style0 from "./VideoList.vue?vue&type=style&index=0&id=c2c2a182&prod&lang=scss&scoped=true"
import style1 from "./VideoList.vue?vue&type=style&index=1&id=c2c2a182&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c2a182",
  null
  
)

export default component.exports